import { render } from "./CalenderEventEditor.vue?vue&type=template&id=128087de&scoped=true"
import script from "./CalenderEventEditor.vue?vue&type=script&lang=js"
export * from "./CalenderEventEditor.vue?vue&type=script&lang=js"

import "./CalenderEventEditor.vue?vue&type=style&index=0&id=128087de&lang=scss&scoped=true"
import "./CalenderEventEditor.vue?vue&type=style&index=1&id=128087de&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128087de"]])

export default __exports__